var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManageUsersIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16,
  fill: "none",
  viewBox: "0 0 18 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M11.6 3.667a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.3,
  d: "M11.009 2.096a2.058 2.058 0 1 1 .753 2.812M6.991 2.096a2.058 2.058 0 1 0-.753 2.812"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M9 8.542c4.486 0 5.595 3.684 5.869 5.505.082.546-.358.995-.91.995H4.042c-.552 0-.992-.449-.91-.995.274-1.82 1.382-5.505 5.868-5.505Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m16.927 11.79-.632.152zm-6.75-3.155-.48-.439-.806.884 1.18.196zm4.436 4.24-.624.18.135.47h.49zm-1.821-4.767c1.09 0 1.851.54 2.413 1.307.575.785.908 1.772 1.09 2.527l1.263-.305c-.199-.826-.582-2.004-1.304-2.99-.735-1.004-1.85-1.839-3.462-1.839zm-2.134.965c.525-.575 1.206-.965 2.134-.965v-1.3c-1.354 0-2.367.592-3.094 1.388zm-.587.203c2.433.404 3.466 2.218 3.918 3.78l1.249-.362c-.516-1.782-1.807-4.178-4.954-4.7zm5.949 2.949h-1.407v1.3h1.407zm.275-.283a.2.2 0 0 1-.043.184.3.3 0 0 1-.232.099v1.3c.957 0 1.788-.851 1.538-1.888z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m7.823 8.635.106.64 1.18-.195-.806-.884zM1.074 11.79l.632.152zm2.313 1.085v.65h.489l.136-.47zM5.21 8.108c.928 0 1.608.39 2.134.965l.96-.877c-.727-.796-1.74-1.388-3.094-1.388zm-3.503 3.834c.182-.755.515-1.742 1.09-2.527.561-.766 1.323-1.307 2.413-1.307v-1.3c-1.612 0-2.727.835-3.462 1.84-.722.985-1.106 2.163-1.305 2.99zm.274.283a.3.3 0 0 1-.232-.099.2.2 0 0 1-.042-.184l-1.264-.305c-.25 1.037.581 1.888 1.538 1.888zm1.407 0H1.98v1.3h1.407zm.625.83c.452-1.561 1.485-3.375 3.917-3.78l-.213-1.281c-3.147.522-4.437 2.918-4.953 4.7z"
})));
export { SvgManageUsersIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/manageUsersIcon.svg";